import { Component, Input } from '@angular/core';
import { SLASH } from '@shared/models/shared.model';
import { Category, FacetValue, TranslatePipe } from '@spartacus/core';
import { FacetComponent, FocusDirective, AtMessageDirective } from '@spartacus/storefront';
import { NgIf, NgFor, AsyncPipe, SlicePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-efa-facet',
    templateUrl: './efa-facet.component.html',
    imports: [
        NgIf,
        NgFor,
        RouterLink,
        FocusDirective,
        AtMessageDirective,
        AsyncPipe,
        SlicePipe,
        TranslatePipe,
    ],
})
export class EfaFacetComponent extends FacetComponent {
  @Input() currentCategory: Category;

  getFacetValueClass(facetValue: FacetValue): string {
    if (!this.facet.category) {
      return '';
    }

    const depth: number = this.getPathDepth(facetValue.code);
    if (depth === 1) {
      return '';
    }

    if (depth === 2) {
      return 'pl-2';
    }

    if (depth === 3) {
      return 'pl-4';
    }

    if (depth === 4) {
      return 'pl-5';
    }
  }

  isReadOnly(facetValue: FacetValue): boolean {
    if (!this.facet.category) {
      return false;
    }

    const currentCategoryPath: string = this.facet.values.find(
      (facetValue: FacetValue) =>
        facetValue.code.endsWith(SLASH + this.currentCategory.code),
    )?.code;
    return (
      facetValue.code === currentCategoryPath ||
      currentCategoryPath.startsWith(facetValue.code + SLASH) ||
      this.isSelectedParent(facetValue)
    );
  }

  private isSelectedParent(facetValue: FacetValue): boolean {
    return (
      facetValue.selected &&
      this.facet.values.find(
        (facetValueFromFacet: FacetValue) =>
          facetValueFromFacet.code.startsWith(facetValue.code) &&
          facetValueFromFacet.code !== facetValue.code &&
          facetValueFromFacet.selected,
      ) != null
    );
  }

  private getPathDepth(path: string): number {
    return path.split(SLASH).length - 1;
  }
}
